(function() { window.GUID_f3ef1e0f_5bf0_4fd2_9765_792db5ee6d92 = { getGuid: function() { return "f3ef1e0f-5bf0-4fd2-9765-792db5ee6d92"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Bracket extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.isDragging = false;
                this.shouldKeepBracketDrawerOpen = false;
                this.PreventMatchSelection = false;
            }
            OnBindEvents() {
                var me = this;
                let firstCall = true;
                CS.Controls.ControlBase.BaseEvents.ControlBaseLoaded(CS.Controls.DragZoom, {
                    selector: "#dragzoom-" + me.ControlId,
                    callback: (control, e) => {
                        if (!firstCall) {
                            me.DragZoom = control;
                            me.DiscoverUI();
                            //me.FixHeaderHeights();
                            me.bindEvents();
                            var alreadyScrolled = me.handleHighlightedElements();
                            if (!alreadyScrolled) {
                                alreadyScrolled = CS.Views.MasterPage.ApplyLastPageState(true);
                                if (!alreadyScrolled) {
                                    me.DragZoom.CenterElement(me.findFirstItemOfColumn0(), true, true);
                                }
                            }
                            me.DragZoom.RemoveContentTransparency();
                        }
                        firstCall = false;
                    },
                });
                me.$Control.on("mousedown.bracket", function () {
                    me.isDragging = false;
                });
                me.$Control.on("mousemove.bracket", function () {
                    me.isDragging = true;
                });
                me.$Control.on("mouseup.bracket", function () {
                    setTimeout(() => {
                        // Using setTimeout with a delay of 0 milliseconds is a way to defer
                        // the execution of a function until the call stack is clear.
                        // By using this, we make sure that the isDragging flag is set to false
                        // after the current event loop has finished executing (i.e. after the "click.bracket" event).
                        me.isDragging = false;
                    }, 0);
                });
            }
            get ControlId() {
                return this.$Control.attr("id");
            }
            get $Control() {
                return this.$Bracket;
            }
            OnDispose() {
                this.$Control.remove();
            }
            OnControlInstantiation(params) {
                let me = this;
                this.shouldKeepBracketDrawerOpen =
                    CS.Cookie.GetCookie("ShouldKeepBracketDrawerOpen") == "1";
                me.$HighligtedPath = new Array();
                this.$Bracket = $(params[0]); //contient le Id
            }
            findFirstItemOfColumn0() {
                return this.$Control.find(".default").first();
            }
            FixHeaderHeights() {
                //let me = this;
                //// Il y avait un léger glitch : Lorsqu'on zoom in/out, la hauteur des BracketHeaders n'était pas exactement identique.
                //// En ajoutant le CSS du height aux 2 header, on s'assure qu'ils sont exactement la même hauteur.
                //if (me.BracketHeader0.$Header.height() > me.BracketHeader1.$Header.height()) {
                //    var emValueHeader = CS.Helper.ConvertPxToEm(me.BracketHeader0.$Header.height(), me.BracketHeader0.$Header);
                //    me.BracketHeader1.SetEmHeight(emValueHeader);
                //    me.BracketHeader0.SetEmHeight(emValueHeader);
                //}
                //else {
                //    var emValue = CS.Helper.ConvertPxToEm(me.BracketHeader1.$Header.height(), me.BracketHeader1.$Header);
                //    me.BracketHeader0.SetEmHeight(emValue);
                //    me.BracketHeader1.SetEmHeight(emValue);
                //}
                //var section2emValueHeader = CS.Helper.ConvertPxToEm(me.BracketHeader2.$Header.height(), me.BracketHeader2.$Header);
                //me.BracketHeader2.SetEmHeight(section2emValueHeader);
            }
            ScrollToMatch($matchBox, noAnimation) {
                let me = this;
                me.DragZoom.CenterElement($matchBox, noAnimation, false, function () {
                    me.DragZoom.RemoveContentTransparency();
                });
            }
            ScrollToMatchNumber(matchNumber, noAnimation) {
                let me = this;
                let $dest = me.GetMatchBoxFromMatchNumber(matchNumber);
                if ($dest.length == 0) {
                    return false;
                }
                me.DragZoom.CenterElement($dest, noAnimation, false, function () {
                    me.clearSelectedEncounter();
                    me.highlightMatch($dest);
                    me.DragZoom.RemoveContentTransparency();
                });
                return true;
            }
            GetMatchBoxFromMatchNumber(matchNumber, isTop) {
                // Here, we need to use the data-mn attribute to find the matches since their might be multiple matches with the same match number.
                // Therefore, selecting by id is not sufficient as it will only return the first match with that id.
                let $matches = this.$Bracket.find(`.enc[data-mn="${matchNumber}"]`);
                if ($matches.length > 0 && isTop != null) {
                    const $filtered = $matches.filter(".fake");
                    if ($filtered.length === 2) {
                        if (isTop == true) {
                            return $filtered.find(".oppo.t").closest(".enc");
                        }
                        else {
                            return $filtered.find(".oppo.b").closest(".enc");
                        }
                    }
                }
                return $matches;
            }
            ReplaceContent(newContent, hasChangedOnly = false) {
                let me = this;
                let $newContent = $(newContent);
                if (hasChangedOnly) {
                    let $hasChangedNewMatches = $newContent.find(".bracket__match.has-changed");
                    $.each($hasChangedNewMatches, (i, match) => {
                        let $newMatch = $(match);
                        let id = $newMatch.data("ei");
                        let $oldMatch = this.$Bracket.find('.bracket__match[data-ei="' + id + '"]');
                        if ($newMatch.find(".bracket__match-footer.has-changed").length > 0) {
                            $oldMatch.find(".bracket__match-footer").addClass("xyz-out");
                        }
                        let $hasChangedNewOpps = $newMatch.find(".bracket__match-opponent.has-changed");
                        $.each($hasChangedNewOpps, (j, opp) => {
                            let $opp = $(opp);
                            if ($opp.hasClass("t")) {
                                $oldMatch.find(".t").addClass("xyz-out");
                            }
                            else if ($opp.hasClass("b")) {
                                $oldMatch.find(".b").addClass("xyz-out");
                            }
                        });
                    });
                }
                else {
                    const $opps = this.$Bracket.find(".bracket__match-opponent");
                    const $footers = this.$Bracket.find(".bracket__match-footer");
                    const $itemsToAnimate = $opps.add($footers);
                    $itemsToAnimate.addClass("xyz-out");
                }
                me.$Bracket.data("specialparameters", $newContent.data("specialparameters"));
                CS.Lag("refresh-content", 600, () => {
                    // this.ClearSelectedEncounter();
                    me.$Bracket.removeClass("opponent-highlighted");
                    me.$Bracket.removeClass("match-highlighted");
                    me.$Bracket[0].innerHTML = $newContent[0].innerHTML;
                    me.reflectHighlightsFromHighlightInfos();
                    me.DiscoverUI();
                    //me.FixHeaderHeights();
                });
            }
            reflectHighlightsFromHighlightInfos() {
                let $match = this.$Bracket.find(".bracket__match.highlighted");
                if ($match.length > 0) {
                    this.highlightMatch($match);
                    this.highlightWinnerLoser($match);
                    this.highlightSource($match);
                    let $opps = this.$Bracket.find(".bracket__match-opponent.highlighted");
                    if ($opps.length > 0) {
                        this.highlightOpponent($opps);
                    }
                }
            }
            DiscoverUI() {
                let me = this;
                me.BracketHeader1 = new Controls.BracketHeader(me, 1);
                me.BracketHeader0 = new Controls.BracketHeader(me, 0);
                me.BracketHeader2 = new Controls.BracketHeader(me, 2);
            }
            bindEvents() {
                let me = this;
                me.$Control.parent().offon("click.bracket", function (e) {
                    if (me.isDragging ||
                        /*me.DragZoom.HasMoved() || */ e.target.tagName == "A") {
                        return;
                    }
                    let $clicked = $(e.target);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    //click sur winner to, loser to, winner of, loser of
                    if ($clicked.hasClass("wto") ||
                        $clicked.hasClass("lto") ||
                        $clicked.hasClass("wof") ||
                        $clicked.hasClass("lof")) {
                        const dest = me.getDestinationFromEnc($clicked);
                        const entityBaseId = me.getOpponentIdFromClicked($clicked, dest);
                        if (entityBaseId != null) {
                            const $targetMatch = me.GetMatchBoxFromMatchNumber(dest);
                            const $targetOpponent = $targetMatch.find(`[data-eid="${entityBaseId}"]`);
                            if ($targetOpponent.length) {
                                me.onEncounterSelected($targetMatch, $targetOpponent, e, undefined, true, CS.Cookie.GetCookie("ShouldKeepBracketDrawerOpen") !== "1");
                                return;
                            }
                        }
                        me.ScrollToMatchNumber(dest, false);
                        return;
                    }
                    let $enc = $clicked.closest(".enc");
                    if ($enc.length > 0) {
                        let $opponent = $clicked.closest(".oppo");
                        me.onEncounterClicked($enc, $opponent, e);
                        return;
                    }
                    if ($clicked.closest(".sections-headers").length > 0) {
                        //me.$Bracket.toggleClass('hide-text');
                        let text = $clicked.closest(".col-header").find(".text-content");
                        if (text.length > 0) {
                            //let newText = text.clone();
                            CS.Controls.Popup.ShowMessage(text.text());
                        }
                    }
                    me.clearSelectedEncounter();
                });
                if (this.DragZoom != null) {
                    me.bindHeadersAutoPositioningOnScrolling();
                }
            }
            onEncounterClicked($encounter, $opponent, e) {
                if (e != null) {
                    const $target = $(e.target);
                    const isMatchDetailsButtonClick = $target.is(".button-show-match-details");
                    const $parentMatchDetailsButton = $target.closest(".button-show-match-details");
                    const isClickWithinMatchDetailsButton = $parentMatchDetailsButton.length > 0;
                    if (!isMatchDetailsButtonClick && isClickWithinMatchDetailsButton) {
                        $parentMatchDetailsButton.trigger("click");
                        return;
                    }
                    const isMatchStreamButtonClick = $target.is(".button-show-match-stream");
                    const $parentMatchStreamButton = $target.closest(".button-show-match-stream");
                    const isClickWithinMatchStreamButton = $parentMatchStreamButton.length > 0;
                    if (!isMatchStreamButtonClick && isClickWithinMatchStreamButton) {
                        $parentMatchStreamButton.trigger("click");
                        return;
                    }
                    const isWatchStreamButtonClick = $target.is(".button-show-watch-stream");
                    const $parentWatchStreamButton = $target.closest(".button-show-watch-stream");
                    const isClickWithinWatchStreamButton = $parentWatchStreamButton.length > 0;
                    if (!isWatchStreamButtonClick && isClickWithinWatchStreamButton) {
                        $parentWatchStreamButton.trigger("click");
                        return;
                    }
                }
                if (this.PreventMatchSelection) {
                    CS.Debug.Log(`PreventMatchSelection = ${this.PreventMatchSelection}`);
                    return;
                }
                if ($encounter == null) {
                    return;
                }
                // if ($encounter.hasClass("fake")) {
                //   this.clearSelectedEncounter();
                //   return;
                // }
                this.onEncounterSelected($encounter, $opponent, e, $encounter.hasClass("fake"));
                let selectedOpponentId = null;
                if ($opponent.length > 0) {
                    selectedOpponentId = $opponent.data("eid");
                }
            }
            handleHighlightedElements() {
                let alreadyScrolled = false;
                this.$SelectedOpponent = this.$Control.find(".oppo.highlighted");
                this.$SelectedEncounter = this.$Control.find(".enc.highlighted");
                if (this.$SelectedEncounter.length > 0) {
                    if (this.$SelectedOpponent.length > 0) {
                        this.$Bracket.addClass("opponent-highlighted");
                    }
                    this.$Bracket.addClass("match-highlighted");
                    this.ScrollToMatch(this.$SelectedEncounter, true);
                    alreadyScrolled = true;
                }
                return alreadyScrolled;
            }
            onEncounterSelected($encounter, $opponent, e, isFake, shouldScroll, preventBracketDrawer) {
                if (this.PreventMatchSelection) {
                    CS.Debug.Log(`PreventMatchSelection = ${this.PreventMatchSelection}`);
                    return;
                }
                if (shouldScroll) {
                    this.ScrollToMatch($encounter, false);
                }
                this.clearSelectedEncounter();
                this.highlightMatch($encounter);
                this.highlightWinnerLoser($encounter);
                this.highlightOpponent($opponent);
                this.highlightSource($encounter);
                let data = {
                    matchId: $encounter.data("ei"),
                    opponentId: $opponent.data("eid"),
                    matchNumber: $encounter[0].id.replace("mn-", ""),
                    $selectedEncounter: $encounter,
                    isFake: isFake,
                    preventBracketDrawer: preventBracketDrawer,
                };
                this.Trigger(Bracket.EventNames.MatchSelectionChanged, {
                    jqueryEventObject: e,
                    data: data,
                });
            }
            ClearSelectedEncounter() {
                this.clearSelectedEncounter();
            }
            clearSelectedEncounter() {
                let me = this;
                const data = {
                    matchId: null,
                    opponentId: null,
                    matchNumber: null,
                    $selectedEncounter: this.$SelectedEncounter,
                };
                this.$Bracket.removeClass("suggested-bye-highlighted");
                this.$Bracket.removeClass("match-highlighted");
                this.$Bracket.removeClass("opponent-highlighted");
                if (me.$SelectedEncounter != null) {
                    me.$SelectedEncounter.removeClass("highlighted");
                    me.$SelectedEncounter = null;
                }
                if (me.$SelectedOpponent != null) {
                    me.$SelectedOpponent.removeClass("highlighted");
                    me.$SelectedOpponent = null;
                    $.each(me.$HighligtedPath, function (i, e) {
                        $(e).removeClass("highlighted__path");
                    });
                }
                if (me.$WinnerHighlightedEncounter != null) {
                    me.$WinnerHighlightedEncounter.removeClass("wht");
                    me.$WinnerHighlightedEncounter.removeClass("whb");
                    me.$WinnerHighlightedEncounter = null;
                }
                if (me.$LoserHighlightedEncounter != null) {
                    me.$LoserHighlightedEncounter.removeClass("lht");
                    me.$LoserHighlightedEncounter.removeClass("lhb");
                    me.$LoserHighlightedEncounter = null;
                }
                if (me.$SourceHighlightedEncounter != null) {
                    me.$SourceHighlightedEncounter.removeClass("why");
                    me.$SourceHighlightedEncounter = null;
                }
                this.Trigger(Bracket.EventNames.SelectedEncounterCleared, {
                    jqueryEventObject: null,
                    data: data,
                });
                this.Trigger(Bracket.EventNames.MatchSelectionChanged, {
                    jqueryEventObject: null,
                    data: data,
                });
            }
            highlightOpponent($opponent) {
                let me = this;
                if ($opponent) {
                    let entityBaseId = $opponent.data("eid");
                    if (entityBaseId != "" && entityBaseId != undefined) {
                        me.$HighligtedPath.length = 0;
                        let $allBoxOfEntityBaseId = this.$Bracket.find("[data-eid=" + entityBaseId + "]");
                        $.each($allBoxOfEntityBaseId, function (i, e) {
                            let $match = $(e).closest(".enc");
                            me.$HighligtedPath.push($match);
                            $match.addClass("highlighted__path");
                        });
                        this.$SelectedOpponent = $allBoxOfEntityBaseId;
                        this.$SelectedOpponent.addClass("highlighted");
                        this.$Bracket.addClass("opponent-highlighted");
                    }
                }
            }
            highlightWinnerLoser($encounter) {
                let me = this;
                let wd = me.getWinDestinationFromEncounter($encounter);
                let ld = me.getLostDestinationFromEncounter($encounter);
                if (wd != null) {
                    let wdEnc = me.GetMatchBoxFromMatchNumber(wd.matchNumber, wd.isTop);
                    me.$WinnerHighlightedEncounter = wdEnc;
                    me.$WinnerHighlightedEncounter.addClass(wd.isTop ? " wht" : " whb");
                }
                if (ld != null) {
                    let ldEnc = me.GetMatchBoxFromMatchNumber(ld.matchNumber, wd.isTop);
                    me.$LoserHighlightedEncounter = ldEnc;
                    me.$LoserHighlightedEncounter.addClass(ld.isTop ? " lht" : " lhb");
                }
            }
            highlightSource($encounter) {
                let me = this;
                let rfNumber = $encounter.data("rf");
                if (rfNumber != null) {
                    let wdEnc = this.$Bracket.find('.bracket__match[data-ei="' + rfNumber + '"]');
                    me.$SourceHighlightedEncounter = wdEnc;
                    me.$SourceHighlightedEncounter.addClass(" why");
                }
            }
            getWinDestinationFromEncounter($encounter) {
                let value = $encounter.data("wd");
                if (value) {
                    let split = value.split("-");
                    return {
                        matchNumber: parseInt(split[0]),
                        isTop: split[1] == "t",
                    };
                }
                else
                    return null;
            }
            getLostDestinationFromEncounter($encounter) {
                let value = $encounter.data("ld");
                if (value) {
                    let split = value.split("-");
                    return {
                        matchNumber: parseInt(split[0]),
                        isTop: split[1] == "t",
                    };
                }
                else
                    return null;
            }
            getDestinationFromEnc(clickedDest) {
                let me = this;
                let dest = null;
                let encParent = clickedDest.closest(".enc");
                if (clickedDest.hasClass("wto")) {
                    return me.getWinDestinationFromEncounter(encParent).matchNumber;
                }
                else if (clickedDest.hasClass("lto")) {
                    return me.getLostDestinationFromEncounter(encParent).matchNumber;
                }
                else {
                    return clickedDest.data("dest");
                }
            }
            getMatchNumberFromClicked($clicked) {
                if (!$clicked.length) {
                    return null;
                }
                const matchNumber = $clicked.data("mn");
                if (matchNumber != null) {
                    return matchNumber;
                }
                const $closestEncounter = $clicked.closest(".enc");
                if ($closestEncounter.length > 0) {
                    return $closestEncounter.data("mn");
                }
                return null;
            }
            getOpponentIdFromClicked($clicked, targetMatchNumber) {
                const currentMatchNumber = this.getMatchNumberFromClicked($clicked);
                if (currentMatchNumber == null) {
                    return null;
                }
                const $currentMatch = this.GetMatchBoxFromMatchNumber(currentMatchNumber);
                const $targetMatch = this.GetMatchBoxFromMatchNumber(targetMatchNumber);
                const currentMatchHasWinner = $currentMatch.find(".win").length > 0;
                const targetMatchHasWinner = $targetMatch.find(".win").length > 0;
                if ($clicked.hasClass("wto")) {
                    if (!currentMatchHasWinner) {
                        return null;
                    }
                    const $currentMatchWinner = $currentMatch.find(".oppo.win");
                    return $currentMatchWinner.data("eid");
                }
                else if ($clicked.hasClass("lto")) {
                    if (!currentMatchHasWinner) {
                        return null;
                    }
                    const $currentMatchLoser = $currentMatch.find(".oppo:not(.win):not(.bye)");
                    return $currentMatchLoser.length > 0
                        ? $currentMatchLoser.data("eid")
                        : null;
                }
                else if ($clicked.hasClass("wof")) {
                    if (!targetMatchHasWinner) {
                        return null;
                    }
                    const $targetMatchWinner = $targetMatch.find(".oppo.win");
                    return $targetMatchWinner.data("eid");
                }
                else if ($clicked.hasClass("lof")) {
                    if (!targetMatchHasWinner) {
                        return null;
                    }
                    const $targetMatchLoser = $targetMatch.find(".oppo:not(.win):not(.bye)");
                    return $targetMatchLoser.length > 0
                        ? $targetMatchLoser.data("eid")
                        : null;
                }
                return null;
            }
            HighlightMatch($match) {
                this.highlightMatch($match);
            }
            highlightMatch(match) {
                this.$SelectedEncounter = match;
                match.addClass("highlighted");
                this.$Bracket.addClass("match-highlighted");
            }
            bindHeadersAutoPositioningOnScrolling() {
                let me = this;
                //CS.Controls.DragZoom.Events.Scrolled({
                //    selector: "#" + me.DragZoom.ControlId,
                //    callback: (ctrl, e) => {
                //        me.BracketHeader0.UpdateUIWhileSticky();
                //        me.BracketHeader1.UpdateUIWhileSticky();
                //        me.BracketHeader2.UpdateUIWhileSticky();
                //    }
                //});
                //CS.Controls.DragZoom.Events.TouchStarted({
                //    selector: "#" + me.DragZoom.ControlId,
                //    callback: (ctrl, e) => {
                //        me.BracketHeader0.UpdateUIWhileSticky();
                //        me.BracketHeader1.UpdateUIWhileSticky();
                //        me.BracketHeader2.UpdateUIWhileSticky();
                //    }
                //});
            }
            HighlightOpponent(entityId, $encounter, callback) {
                const $selectedEncounter = $encounter == null ? this.$SelectedEncounter : $encounter;
                if ($selectedEncounter != null && $selectedEncounter.length) {
                    const $opponent = $selectedEncounter.find(`[data-eid="${entityId}"]`);
                    if ($opponent.length) {
                        this.onEncounterClicked($selectedEncounter, $opponent, null);
                    }
                }
                if (callback) {
                    callback.call(this);
                }
            }
        }
        Controls.Bracket = Bracket;
        (function (Bracket) {
            class Events {
                /**
                 * Called before "MatchSelectionChanged"
                 * @param param
                 */
                static SelectedEncounterCleared(param) {
                    Controls.RegisterEvent(Bracket, EventNames.MatchSelectionChanged, param);
                }
                static MatchSelectionChanged(param) {
                    Controls.RegisterEvent(Bracket, EventNames.MatchSelectionChanged, param);
                }
            }
            Bracket.Events = Events;
            class EventNames {
            }
            EventNames.SelectedEncounterCleared = "bracket-match-selectedencountercleared";
            EventNames.MatchSelectionChanged = "bracket-match-selectionchanged";
            Bracket.EventNames = EventNames;
        })(Bracket = Controls.Bracket || (Controls.Bracket = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=bracket.js.map
